document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('[data-sticky-atc]');
  if (!sticky) return;

  const formId = sticky.getAttribute('data-main-form-id');
  const form = formId ? document.getElementById(formId) : null;
  if (!form) return;

  const submitButton = form.querySelector('[type="submit"][name="add"]');
  const variantInput = form.querySelector('input[name="id"], select[name="id"]');
  const stickySelect = sticky.querySelector('[data-sticky-variant-select]');
  const stickySubmit = sticky.querySelector('[data-sticky-atc-submit]');
  const stickyPrice = sticky.querySelector('.nn-stickyATC__price');
  const variantsJsonEl = document.querySelector('[data-variants-json]');
  const variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];

  const formatMoney = (cents) => {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || undefined);
    }
    const amount = (Number(cents) / 100).toFixed(2);
    return `£${amount}`;
  };

  const syncFromForm = () => {
    if (!variantInput || !stickySelect) return;
    const id = String(variantInput.value);
    if (stickySelect.value !== id) {
      const option = stickySelect.querySelector(`option[value="${id}"]`);
      if (option) stickySelect.value = id;
    }
    const variant = variants.find((v) => String(v.id) === id);
    if (variant && stickyPrice) {
      stickyPrice.textContent = formatMoney(variant.price);
    }
    if (stickySubmit && submitButton) {
      stickySubmit.disabled = submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true';
    }
  };

  if (stickySelect && variantInput) {
    stickySelect.addEventListener('change', () => {
      const id = stickySelect.value;
      variantInput.value = id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      const variantSelects = document.querySelector('variant-selects');
      if (variantSelects && typeof variantSelects.updateSelectionMetadata === 'function') {
        /* Dawn may refresh via section rendering; keep input in sync */
      }

      const optionInputs = form.closest('.product')?.querySelectorAll('variant-selects input[type="radio"], variant-selects select');
      const variant = variants.find((v) => String(v.id) === id);
      if (variant && optionInputs) {
        variant.options.forEach((optVal, index) => {
          const radios = document.querySelectorAll(
            `variant-selects input[type="radio"][name="options[${index}]"], variant-selects fieldset[data-index="${index}"] input[type="radio"]`
          );
          radios.forEach((radio) => {
            if (radio.value === optVal) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          const select = document.querySelector(`variant-selects select[name="options[${index}]"]`);
          if (select) {
            select.value = optVal;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      syncFromForm();
    });
  }

  if (stickySubmit) {
    stickySubmit.addEventListener('click', () => {
      if (submitButton && !submitButton.disabled) {
        submitButton.click();
      }
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (stickySelect) {
        const option = stickySelect.querySelector(`option[value="${variant.id}"]`);
        if (option) stickySelect.value = String(variant.id);
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickySubmit) stickySubmit.disabled = !variant.available;
    });
  }

  const observerTarget = submitButton || form;
  if ('IntersectionObserver' in window && observerTarget) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        sticky.classList.toggle('is-active', !entry.isIntersecting);
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(observerTarget);
  } else {
    sticky.classList.add('is-active');
  }

  syncFromForm();
  form.addEventListener('change', syncFromForm);
});
